import equal from 'fast-deep-equal'

export const returnSecondIfDeepEqual = (first, second) => (equal(first, second) ? second : first)
